import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'nd-footer',
  template: `<div class="nd-footer" [ngStyle]="inlineStyle">
  <ng-content></ng-content>
</div>
`,
  styles: [`.nd-footer{position:absolute;bottom:0;left:0;margin:0;padding:13px 20px 10px;width:100%;background-color:#fff;border-top:1px solid #ccc;-webkit-box-sizing:border-box;box-sizing:border-box}.nd-footer p{margin:3px 0}.nd-footer p.primary{font-weight:700;font-size:14px;text-transform:uppercase}.nd-footer p.secondary{opacity:.8;font-size:12px}`]
})
export class FooterComponent implements OnInit {

  @Input("style") inlineStyle:any;

  constructor() { }

  ngOnInit() {
  }

}
